import { render, staticRenderFns } from "./FileInfo.vue?vue&type=template&id=27c78a2f&"
import script from "./FileInfo.vue?vue&type=script&lang=js&"
export * from "./FileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports